export default __webpack_public_path__ + "static/media/bland-s.2c204f4c.webp";